<template>
  <CreateUpdateTemplate :routePreventDialog="routePreventDialog" customClass="role-create create-form">
    <template v-slot:header-title>
      <v-layout class="border-bottom">
        <v-flex>
          <h3 class="font-weight-700 mb-0 font-size-24 custom-headline color-custom-blue">
            {{ zoneData.name }}

            <v-chip small :color="zoneData.is_active == '1' ? 'green' : 'red'" text-color="white darken-2"
              class="font-weight-600 px-3" style="height: 24px">
              {{ zoneData.is_active == '1' ? 'Active' : 'In-Active' }}
            </v-chip>
          </h3>
          <p class="mb-0">Manage postal codes and zone settings</p>
        </v-flex>
        <v-flex class="text-right">
          <v-btn depressed class="custom-grey-border custom-bold-button" v-on:click="goBack">
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <v-row>
        <v-col md="2" class="py-0 pr-0">
          <div class="border-right pr-2">
            <!-- Header -->
            <div class="d-flex align-center justify-space-between px-2 py-2 mb-2 grey lighten-4">
              <span class="font-weight-600 text-h6 mr-2">Zones</span>
              <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Search..." dense hide-details
                solo flat class="ma-0"></v-text-field>
            </div>

            <!-- Scrollable Zone List -->
            <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shado"
              style="height: calc(100vh - 190px); position: relative">
              <v-row>
                <v-col cols="12" sm="12" class="py-1" v-for="(zone, i) in filteredZones" :key="i">
                  <v-card outlined class="px-3 py-2 rounded-lg zone-card" :disabled="pageLoading"
                    :class="{ 'zone-selected': selectedZone === zone.id }" @click="toggleZone(zone.id)">
                    <!-- Header -->
                    <div class="d-flex justify-space-between align-center mb-0">
                      <span class="font-size-15 font-weight-600">{{
                        zone.name
                      }}</span>

                      <v-chip small :color="zone.is_active === 1
                        ? 'green lighten-5'
                        : 'grey lighten-3'
                        " :text-color="zone.is_active === 1
                          ? 'green darken-2'
                          : 'grey darken-2'
                          " class="font-weight-600 px-3" style="height: 20px">
                        {{ zone.is_active == '1' ? 'Active' : 'In-Active' }}
                      </v-chip>
                    </div>

                    <!-- Details -->
                    <div class="mb-0">
                      <p class="mb-0">
                        <v-icon small color="green darken-2" class="mr-2">mdi-map-marker</v-icon>
                        <span class="green--text fw-600">{{
                          zone.activepostalCodes
                        }}</span>
                        active postal codes
                      </p>
                      <p class="mb-0">
                        <v-icon small color="red darken-2" class="mr-2">mdi-map-marker</v-icon>
                        <span class="red--text fw-600">{{
                          zone.inactivepostalCodes
                        }}</span>
                        inactive postal codes
                      </p>

                      <p class="mb-0">
                        <v-icon small color="grey darken-2" class="mr-2">mdi-account-multiple</v-icon>
                        {{ zone.drivers }} Cleaners assigned
                      </p>

                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </perfect-scrollbar>
          </div>
        </v-col>
        <v-col md="10" class="pt-0">
          <v-tabs active-class="custom-tab-active" v-model="zonesTab" background-color="transparent" color="cyan"
            class="custom-tab-transparent tab-sticky">
            <v-tab class="font-size-16 font-weight-600 px-8" href="#postal-codes">
              Postal Codes
            </v-tab>
            <v-tab class="font-size-16 font-weight-600 px-8" href="#drivers">
              Cleaners
            </v-tab>
            <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
              Import History
            </v-tab>
            <v-tab class="font-size-16 font-weight-600 px-8" href="#settings">
              Settings
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="zonesTab">
            <v-tab-item value="postal-codes">
              <PostalCodes :zone-id="Number(zoneId)" :zone-list="zones" @refreshZones="getZone(zoneId)" />
            </v-tab-item>
            <v-tab-item value="drivers">
              <ZoneDrivers @refreshZones="getZone(zoneId)" />
            </v-tab-item>
            <v-tab-item value="history">
              <ImportHistory />
            </v-tab-item>
            <v-tab-item value="settings">
              <v-container fluid>
                <v-card class="pa-5 mt-2 rounded-lg" outlined>
                  <h5>Zone Settings</h5>
                  <v-form ref="zonesFormSkills" lazy-validation>
                    <v-row>
                      <v-col md="12">
                        <label class="my-auto fw-500 mb-1">Zone Name</label>
                        <TextField dense filled placeholder="Enter zone Name" solo flat counter="50"
                          v-model.trim="zoneData.name" color="cyan" :maxlength="250" />
                      </v-col>

                      <v-col md="12">
                        <label class="my-auto fw-500 mb-1">Status</label>
                        <v-autocomplete hide-details v-model.trim="zoneData.is_active" :items="statusList" dense flat
                          filled item-color="cyan" color="cyan" solo item-value="value" item-text="text"
                          placeholder="Select Status" />
                      </v-col>
                      <v-col md="12">
                        <v-btn depressed small class="white--text" color="cyan" @click="updateZone">
                          <span class="font-size-16 font-weight-600">
                            Save Changes</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import PostalCodes from "@/view/pages/profile/Setting/Zones/PostalCodes.vue";
import ImportHistory from "@/view/pages/profile/Setting/Zones/ImportHistory.vue";
import ZoneDrivers from "@/view/pages/profile/Setting/Zones/ZoneDrivers.vue";
import { GET, POST } from "@/core/services/store/request.module";

export default {
  name: "zone-setting",
  data() {
    return {
      search: null,
      zoneId: 0,
      zones: [],
      zoneData: {},
      selectedZone: null,
      importDialogOpen: false,
      pageLoading: false,
      routePreventDialog: false,
      zonesTab: "postal-codes",
      zonePayload: {
        name: "North Zone",
        status: "Active",
      },

      statusList: [

        {
          text: 'Active',
          value: '1'
        },

        {
          text: 'Inactive',
          value: '0'
        },

      ]

    };
  },
  components: {
    CreateUpdateTemplate,
    PostalCodes,
    ImportHistory,
    ZoneDrivers,
  },

  methods: {
    toggleZone(id) {

      this.selectedZone = this.selectedZone === id ? null : id;
      this.zoneId = this.selectedZone;
      this.$router.push(
        this.getDefaultRoute("zone.view", {
          params: { id: this.selectedZone },
          query: { reload: Date.now() }
        })
      );

    },

    updateZone() {
      const _this = this;
      _this.$store
        .dispatch(POST, {
          url: `update-zone/${this.zoneId}`,
          data: this.zoneData
        })
        .then(() => {
          this.getZone(this.zoneId)
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
        });

    },

    getZone(id) {
      const _this = this;
      this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: `get-zone/${id}`,
        })
        .then((response) => {
          this.zoneData = response.data?.zone;
          this.zones = response.data?.all_zones;

        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          // _this.dataLoading = false;
          _this.pageLoading = false;
          // _this.addZoneDialog = false;
        });
    }


  },
  computed: {
    filteredZones() {
      if (!this.search) return this.zones;
      return this.zones.filter((zone) =>
        zone.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.zoneId = to.params.id;
    this.getZone(this.zoneId);
    next();
  },

  created() {
    this.zoneId = this.$route.params.id;
  },
  mounted() {

    if (this.zoneId) {

      this.getZone(Number(this.zoneId));
    }

  },

  /* beforeRouteLeave(to, from, next) {
      next();
  }, */
};
</script>
<style scoped>
.zone-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.zone-card.zone-selected {
  border: 1.5px solid #1976d2;
  background-color: #e3f2fd;
}
</style>